export const initialFilters = {
    query: "",
};
export const initialProfile = {
    accountStatus: "BLOCK",
    countryId: "",
    createdAt: "",
    email: "",
    firstName: "",
    fullName: "",
    id: "",
    lastName: "",
    phoneNumber: "",
    profileImageUrl: "",
    roleIds: [],
    secondName: "",
    countryName: "",
};
export const initialLocalStore = {};
export const initialGlobalStore = {
    pageSize: 5,
    profile: initialProfile,
};
export const initialTableSettings = {
    pageIndex: 0,
    sortName: "createdAt",
    sortDirection: "DESC",
};
export const initialState = {
    localStore: initialLocalStore,
    globalStore: initialGlobalStore,
};
//# sourceMappingURL=initialState.js.map